import { Product } from "."

export const AddProduct: React.FC = () => {
  return <Product />
}

